export enum EQUIPMENT_TYPE_DISPLAY_NAME {
  V = 'Van Only',
  R ='Reefer Only',
  F = 'Flatbed Only',
  VR = 'Van or Reefer',
  VF = 'Van or Flatbed',
  VRF = 'Van / Reefer / Flatbed',
  C = 'Container',
  PO = 'Power Only',
  HS = 'Hot Shot',
  SD = 'Step Deck',
  RVV = 'Reefer or Vented Van',
  FS ='Flatbed or Stepdeck',
  FC = 'Flatbed or Conestoga',
  T ='Bulk/Tanker'
}

export const EQUIPMENT_SIZES = [
  "53'",
  "48'",
  "45'",
  "40'",
  "32'",
  "20'"
];


// These values must being in km so Cognitive Search use this unit for distance calculations
export const LocationRadiusValues: number[] = [
  0,
  80.47,
  160.93,
  241.4,
  321.87,
  402.34,
  482.8,
  643.74,
  804.67
];

export const APPT_STATUS_ID_MAP: { [key: number]: string } = {
  1: 'By Appointment',
  2: 'FCFS',
  3: 'Drop Trailer',
  4: 'Work In'
}

export const REFERENCE_NUMBER_TYPE_MAP = {
  1: "Customer Ref #",
  2: "SO #",
  3: "BOL #",
  4: "PO #",
  5: "Reference #",
  6: "Notes 1",
  7: "Notes 2",
  8: "Special Instructions",
  9: "Shipment ID",
  10: 'Appointment Number',
  11: "Reference #2",
  12: "Reference #3",
  13: "Rate Quote Reference Id"
};

export enum REFERENCE_NUMBER_ENUM {
  CUSTOMER_REF = 1,
  SO = 2,
  BOL = 3,
  PO = 4,
  REFERENCE = 5,
  NOTES_1 = 6,
  NOTES_2 = 7,
  SPECIAL_INSTRUCTIONS = 8,
  SHIPMENT_ID = 9,
  APPOINTMENT_NUM = 10,
  REFERENCE_2 = 11,
  REFERENCE_3 = 12,
  RATE_QUOTE = 13
}

//LoadStatus.cs denotes status codes with integers but they are resolved as strings.
export enum LoadStatus
    {
        AVAILABLE = "1",
        BOOKED = "2",
        DISPATCHED = "3",
        PICKEDUP = "4",
        DELIVERED = "5",
        FINISHED = "6",
        VOID = "7",
        EXPIRED = "8",
        HOLD = "9",
        ASSIGNED = "10",
        ADMIN_PENDING = "11",
        ADMIN_APPROVED = "12",
        ADMIN_REJECTED = "13",
        LOADING = "14",
        UNLOADING = "15",
        IN_YARD = "16",
        NOT_INVOICED = "17",
    }

export enum COUNTRY_SUGGESTIONS_AVAILABLE
    {
        UNITED_STATES = 1,
        CANADA = 2,
        MEXICO = 3
    }

export const DEFAULT_COUNTRY_SUGGESTION_ID = COUNTRY_SUGGESTIONS_AVAILABLE.UNITED_STATES;

export const notFoundMessage = 'Load Not Found';
export const notAvailableMessage = 'Load Not Available';
export const notViewableMessage = 'Load Not Viewable';

export enum EdiTenderStatusTypeId {
  Unprocessed = 1,
  Expired = 2,
  Accepted = 3,
  Rejected = 4,
  Canceled = 5,
  Ignored = 6
}

export enum EdiTenderTypeId {
  NewTender = 1,
  Cancellation = 2,
  Update = 3
}

export enum AppointmentType {
  ByAppointment = 1,
  FCFS = 2,
  DropTrailer = 3,
  WorkIn = 4
}

export enum LoadStatusId {
  AVAILABLE = 1,
  BOOKED = 2,
  DISPATCHED = 3,
  PICKEDUP = 4,
  DELIVERED = 5,
  FINISHED = 6,
  VOID = 7,
  EXPIRED = 8,
  HOLD = 9,
  ASSIGNED = 10,
  ADMIN_PENDING = 11,
  ADMIN_APPROVED = 12,
  ADMIN_REJECTED = 13,
  LOADING = 14,
  UNLOADING = 15,
  IN_YARD = 16,
  NOT_INVOICED = 17,
}

/**
 *  Constants for Special Services feature
 */
//  Stops
export const DELIVERY_ACCESSORIAL_TYPE = 'DELIVERY_ACCESSORIAL';
export const PICKUP_ACCESSORIAL_TYPE = 'PICKUP_ACCESSORIAL';
export const SPECIAL_SERVICES_SECTION_TYPE = 'Special Requirements';
export const FACILITY_ATTRIBUTES_SECTION_TYPE = 'Facility & location attributes';
export const STOPS_SECTION = 'STOPS';


type SPECIAL_SERVICE_TYPE_RESULT = "PICKUP_ACCESSORIAL" | "DELIVERY_ACCESSORIAL"
export const SPECIAL_SERVICE_TYPE: Record<string, SPECIAL_SERVICE_TYPE_RESULT> ={
  1: PICKUP_ACCESSORIAL_TYPE,
  2: DELIVERY_ACCESSORIAL_TYPE
}
type STOP_SPECIAL_SERVICE_TYPE_RESULT = 'Special Requirements' | "Facility & location";
export const STOP_SPECIAL_SERVICE_TITLE: Record<string, STOP_SPECIAL_SERVICE_TYPE_RESULT> ={
  [SPECIAL_SERVICES_SECTION_TYPE]: SPECIAL_SERVICES_SECTION_TYPE,
  [FACILITY_ATTRIBUTES_SECTION_TYPE]: "Facility & location"
}

export enum LoadTypeId {
  DRY = 1,
  REEFER = 2,
  FLATBED = 3,
  PARTIAL = 4,
  LTL = 5,
  IMDL = 6,
  POWER_ONLY = 7,
  BULK_TANKER = 8,
  PRODUCE = 9,
  DRAYAGE = 10,
  AIR = 11,
}

export enum LoadModeId {
  DRY = 1,
  REEFER = 2,
  FLATBED = 3,
  PARTIAL = 4,
  LTL = 5,
  IMDL = 6,
  POWER_ONLY = 7,
  BULK_TANKER = 8,
  PRODUCE = 9,
  DRAYAGE = 10,
  AIR = 11,
}
// Load
export const LOAD_SECTION = 'LOAD';
export const DRIVER_REQUIREMENTS_SECTION_TYPE = 'Driver Requirements';
export const EQUIPMENT_REQUIREMENTS_SECTION_TYPE = 'Equipment Requirements';
export const EXCESIVE_LENGTH_SECTION_TYPE = 'Excessive Length';


export const LOAD_EQ_SPECIAL_SERVICES_IDS_WITH_VALUE = [
  111,
  112,
  102,
  101
]

export const PERMIT_SPECIAL_SERVICE_ID = 92;

export const MAX_HV_CARGO_VALUE = 500000;
export const MAX_HV_CARGO_VALUE_NON_CERTIFIED = 250000;

export const LOAD_TYPE_ID_MAP: { [key: string]: string } = {
  1: 'Dry',
  2: 'Reefer',
  3: 'Flatbed',
  4: 'Partial',
  5: 'LTL',
  6: 'IMDL',
  7: 'Power Only',
  8: 'Bulk / Tanker',
  9: 'Produce',
  10: 'Drayage',
  11: 'Air',
  12: 'TL',
  13: 'Storage',
  14: 'Ocean',
  15: 'Parcel'
}

export const NEW_LOAD_TYPE_ID_MAP: { [key: string]: string } = {
  ...LOAD_TYPE_ID_MAP,
  1: "TL",
  2: "TL",
  3: "TL"
}

export enum SpecialtyReqsIds {
  PROTECT_FROM_FREEZING = 16,
  TEAM_DRIVERS = 90,
  TANKER_ENDORSEMENT = 91,
  PERMIT = 92,
  LIQUOR_PERMITS = 97,
  PICKUP_TWIC = 61,
  DELIVERY_TWIC = 68,
  PICKUP_BLIND = 118,
  DELIVERY_BLIND = 119,
  PICKUP_LIFTGATE = 2,
  DELIVERY_LIFTGATE = 9,
  PICKUP_PALLET_EXCHANGE = 77,
  DELIVERY_PALLET_EXCHANGE = 78,
  SCALE_TICKET = 81,
  PICKUP_LIGHT_SCALE = 82,
  DELIVERY_LIGHT_SCALE = 83,
  PICKUP_DRIVER_WORK = 55,
  DELIVERY_DRIVER_WORK = 62,
  PICKUP_DRIVER_COUNT = 120,
  DELIVERY_DRIVER_COUNT = 121,
  DRIVER_LOAD = 122,
  DRIVER_UNLOAD = 123,
  NO_ROLL_DOORS = 116,
  E_TRACKS = 113,
  METAL_FLOORS_ONLY = 115
}
